import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import { api } from "@/lib/api";

export const ContentContext = React.createContext({});

export default function Layout() {
  const [content, setContent] = useState(null);
  const { pathname } = useLocation();

  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data)).catch(() => setContent({}));
  }, []);

  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);

  return (
    <div className="min-h-screen bg-ink grain">
      <Header />
      <main className="pt-24 md:pt-28">
        <ContentContext.Provider value={content || {}}>
          <Outlet />
        </ContentContext.Provider>
      </main>
      <Footer contact={content?.contact} />
      <WhatsAppButton phone={content?.contact?.whatsapp} />
    </div>
  );
}
